import React from 'react'
import { Box, IconButton, Tooltip, Fade } from '@mui/material'
import ZoomInIcon from '@mui/icons-material/ZoomIn'
import ZoomOutIcon from '@mui/icons-material/ZoomOut'
import RotateLeftIcon from '@mui/icons-material/RotateLeft'
import CloseIcon from '@mui/icons-material/Close'

const controlButtonStyle = {
  color: 'white',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    transform: 'scale(1.1)'
  },
  '&.Mui-disabled': {
    color: 'rgba(255, 255, 255, 0.3)',
    backgroundColor: 'rgba(0, 0, 0, 0.3)'
  },
  transition: 'transform 0.2s ease'
}

export default function ImageControls({
  showControls,
  onZoomIn,
  onZoomOut,
  onReset,
  onClose,
  canZoomIn,
  canZoomOut,
  currentScale,
  fitScale,
  currentPosition
}) {
  const isResetDisabled =
    Math.abs(currentScale - fitScale) < 0.001 &&
    Math.abs(currentPosition.x) < 0.001 &&
    Math.abs(currentPosition.y) < 0.001

  const showZoomHint = showControls && isResetDisabled

  return (
    <>
      <Fade in={showControls}>
        <Box
          sx={{
            position: 'fixed',
            top: 20,
            right: 20,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '10px',
            zIndex: 1600
          }}
        >
          <ControlButton title='Zoom In (+)' onClick={onZoomIn} disabled={!canZoomIn} icon={<ZoomInIcon />} />

          <ControlButton title='Zoom Out (-)' onClick={onZoomOut} disabled={!canZoomOut} icon={<ZoomOutIcon />} />

          <ControlButton
            title='Reset (0 or R)'
            onClick={onReset}
            disabled={isResetDisabled}
            icon={<RotateLeftIcon />}
          />

          <ControlButton title='Close (Esc)' onClick={onClose} icon={<CloseIcon />} />
        </Box>
      </Fade>

      <Fade in={showControls}>
        <Box
          sx={{
            position: 'fixed',
            bottom: 20,
            left: '50%',
            transform: 'translateX(-50%)',
            color: 'white',
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            padding: '5px 12px',
            borderRadius: '4px',
            fontSize: '14px',
            zIndex: 1600,
            userSelect: 'none'
          }}
        >
          {Math.round(currentScale * 100)}%
        </Box>
      </Fade>

      <Fade in={showZoomHint} timeout={500}>
        <Box
          sx={{
            position: 'fixed',
            bottom: 60,
            left: '50%',
            transform: 'translateX(-50%)',
            color: 'white',
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            padding: '8px 15px',
            borderRadius: '20px',
            fontSize: '13px',
            opacity: 0.85,
            textAlign: 'center',
            maxWidth: 'calc(100vw - 40px)',
            boxSizing: 'border-box',
            zIndex: 1600,
            userSelect: 'none'
          }}
        >
          Use mouse wheel or pinch to zoom. Drag to pan. Keyboard: +/- (zoom), Arrows (pan), 0/R (reset), Esc (close).
        </Box>
      </Fade>
    </>
  )
}

function ControlButton({ title, onClick, disabled, icon }) {
  return (
    <Tooltip title={title} arrow placement='bottom'>
      <span>
        <IconButton
          onClick={e => {
            e.stopPropagation()
            if (onClick) onClick(e)
          }}
          disabled={disabled}
          sx={controlButtonStyle}
          size='medium'
        >
          {icon}
        </IconButton>
      </span>
    </Tooltip>
  )
}
